import { RouteObject } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';

import { Page404, To404 } from '@/404';
import { Layouts } from '@/pages/Layouts';
import { Home } from '@/pages/Home';
import { Services } from '@/pages/Services';
import { Qrcode2Svg } from '@/pages/Services/Qrcode2Svg';
import { MediaSource } from '@/pages/Services/MediaSource';

export interface RouteInfo {
  icon?: any;
  name: string;
  hidden?: boolean;
  children?: (RouteInfo & RouteObject)[];
  redirectTo?: string;
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layouts />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: '/services',
        element: <Services />,
        children: [
          {
            index: true,
            element: <Qrcode2Svg />,
          },
          {
            path: 'qrcode-svg',
            element: <Qrcode2Svg />,
          },
          {
            path: 'media-source',
            element: <MediaSource />,
          },
        ],
      },
    ],
  },
  {
    path: '/404',
    element: <Page404 />,
  },
  {
    path: '*',
    element: <To404 />,
  },
];

const RouteConfig = () => {
  const routeContent = useRoutes(routes);

  return routeContent;
};

export default RouteConfig;
